import { bool, func, number, object, oneOf, string } from 'prop-types'
import { Component, Fragment } from 'react'
import { AreaUploader, kuiperClassNames, Loader } from '@opallabs/kuiper'
import { getUploaderStyles } from '../Helpers/themeHelper'
import ImageSlideAsset from '../ImageSlideAsset'
import Slide from '../Slide'

import './styles.scss'

class ImageSlide extends Component {
  static propTypes = {
    alignment: oneOf(['center', 'fit', 'fill']),
    assetReference: object,
    backgroundImageURL: string,
    getSlide: func,
    presentationId: number,
    slideId: number,
    theme: object,
    thumbnail: bool,
    updateSlide: func,
    uploadAsset: func,
    viewOnlyMode: bool,
    withHoverableOverlay: bool,
  }

  static defaultProps = {
    alignment: 'center',
    theme: {},
    thumbnail: false,
    updateSlide: () => {},
    withHoverableOverlay: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      imageAssetLoading: false,
    }
  }

  get uploaderBackgroundColor() {
    return getUploaderStyles(this.props.theme, ['backgroundColor'])
  }

  updateImageAssetLoading = (value = false) => {
    this.setState({ imageAssetLoading: value })
  }

  uploadInstructions = (file) => {
    const { presentationId, slideId } = this.props

    const updateSlide = ({ data }) => {
      const changes = { canvas_asset_reference_id: data.id }
      this.props.updateSlide(presentationId, slideId, changes)
    }

    this.props.uploadAsset({
      file,
      onUploadSuccess: updateSlide,
    })

    this.updateImageAssetLoading(true)
  }

  render() {
    const {
      alignment,
      assetReference,
      backgroundImageURL,
      getSlide,
      presentationId,
      slideId,
      theme,
      thumbnail,
      updateSlide,
      viewOnlyMode,
      withHoverableOverlay,
    } = this.props

    return (
      <div className={kuiperClassNames('image-slide')}>
        <Slide
          backgroundImageURL={backgroundImageURL}
          getSlide={getSlide}
          presentationId={presentationId}
          slideId={slideId}
          theme={theme}
        >
          <Fragment>
            {!assetReference && (!viewOnlyMode || withHoverableOverlay) && (
              <AreaUploader
                allowableFiles={['image']}
                customStyles={this.uploaderBackgroundColor}
                disabled={viewOnlyMode}
                uploadInstructions={this.uploadInstructions}
              />
            )}
            {assetReference && (
              <div className={kuiperClassNames('asset-container')}>
                <ImageSlideAsset
                  assetReference={assetReference}
                  alignment={alignment}
                  onDelete={() => this.updateImageAssetLoading(false)}
                  presentationId={presentationId}
                  slideId={slideId}
                  thumbnail={thumbnail}
                  updateSlide={updateSlide}
                  viewOnlyMode={viewOnlyMode}
                />
              </div>
            )}
            <Loader
              loaded={!this.state.imageAssetLoading || Boolean(assetReference)}
            />
          </Fragment>
        </Slide>
      </div>
    )
  }
}

export default ImageSlide
